<template>
  <div>
    <div class="home d-flex">
      <div class="intro-text d-flex align-items-end px-md-5">
        <div class="position-relative">
          <h1 :class="{'h1-ua': $i18n.locale === 'ua'}">{{ $t('Bory Družstevné Bývanie') }}</h1>
          <p class="mb-4">{{ $t('Objavte nový spôsob, ako získať bývanie bez potreby hypotéky.') }}</p>
          <b-button to="/byvanie/na-hradzi" class="d-block d-md-inline-block px-5 mb-3 mb-md-0 mr-0 mr-md-3" squared variant="primary">{{ $t('Pozrieť ponuku bytov') }}</b-button>
          <b-button @click="scrollTo('vyhody')" class="d-block d-md-inline-block px-5" squared variant="primary">{{ $t('Výhody družstevného bývania') }}</b-button>
        </div>
      </div>
    </div>

    <section class="section-3 free-offer p-3">
      <div class="">
        <div class="row px-3">
          <div class="col-md-5 p-0 px-md-5 py-5 pb-custom">
            <h2 class="mb-4" v-html="$t('Čo je to <br>družstevné bývanie?')"></h2>
            <p class="mb-5" v-html="$t('Družstevné bývanie je jednoduchý a dostupný spôsob')"></p>
            <b-button to="/byvanie/na-hradzi" class="d-block d-md-inline-block px-5 mb-3 mb-md-0 mr-0 mr-md-3" squared variant="primary">{{ $t('Pozrieť ponuku bytov') }}</b-button>
            <b-button @click="scrollTo('vyhody')" class="d-block d-md-inline-block px-5" squared variant="primary">{{ $t('Výhody družstevného bývania') }}</b-button>
          </div>
          <div class="col-md-7 bg-img"></div>
        </div>
      </div>
    </section>

    <section class="section-3 dark-bg p-3">
      <div class="">
        <div class="row px-3">
          <div class="col-md-7 bg-img-2"></div>
          <div class="col-md-5 p-0 px-md-5 py-5 pb-custom-2">
            <h2 class="mb-4">{{ $t('Družstevné bývanie na Boroch pre všetkých') }}</h2>
            <p class="mb-3">{{ $t('Bory Družstevné Bývanie predstavuje alternatívu') }}</p>
            <p class="mb-5">{{ $t('Hlavnou výhodou tohto modelu sú menej prísne podmienky') }}</p>
            <b-button to="/byvanie/na-hradzi" class="d-block d-md-inline-block px-5" squared variant="primary">{{ $t('Pozrieť ponuku bytov') }}</b-button>
          </div>
        </div>
      </div>
    </section>

    <div class="catalog princip" id="zlavy">
      <div class="container">
        <div id="catalog-slider">
          <h2 class="text-center">{{ $t('Princíp fungovania Bory Družstevného Bývania') }}</h2>
          <div class="row row-cols-5 mb-5">
            <div class="col-12 col-md box">
              <div class="icon">
                <img src="../assets/images/druzstevne/vyberte_byt.svg" alt="">
              </div>
              <div class="text">
                <p class="mb-0 text-center">{{ $t('Vyberiete si byt, o ktorý máte záujem.') }}</p>
              </div>
            </div>
            <div class="col-12 col-md box">
              <div class="icon">
                <img src="../assets/images/druzstevne/podpis_rezervacna_zmluva.svg" alt="">
              </div>
              <div class="text">
                <p class="mb-0 text-center">{{ $t('Podpíšete rezervačnú zmluvu a uhradíte rezervačný poplatok') }}</p>
              </div>
            </div>
            <div class="col-12 col-md box">
              <div class="icon">
                <img src="../assets/images/druzstevne/staci_20_ceny_bytu.svg" alt="">
              </div>
              <div class="text">
                <p class="mb-0 text-center">{{ $t('Po následnej úhrade zvyšnej sumy do 20 % rozhodne o prijatí') }}</p>
              </div>
            </div>
            <div class="col-12 col-md box">
              <div class="icon">
                <img src="../assets/images/druzstevne/bory_druzstevne-byvanie_ikony_prebratie_bytu.svg" alt="">
              </div>
              <div class="text">
                <p class="mb-0 text-center">{{ $t('Po doručení rozhodnutia o prijatí uhradíte poplatky') }}</p>
              </div>
            </div>
            <div class="col-12 col-md box">
              <div class="icon">
                <img src="../assets/images/druzstevne/osobne_vlastnictvo.svg" alt="">
              </div>
              <div class="text">
                <p class="mb-0 text-center">{{ $t('Po splatení celkovej ceny bytu môžete požiadať družstvo') }}</p>
              </div>
            </div>
          </div>
          
          <p class="text-center"><b-button to="/byvanie/na-hradzi" class="d-block d-md-inline-block px-5" squared variant="primary">{{ $t('Pozrieť ponuku bytov') }}</b-button></p>
        </div>
      </div>
    </div>

    <div class="catalog free-offer vyhody" id="vyhody">
      <div class="container">
        <div id="catalog-slider">
          <h2 class="text-center">{{ $t('Výhody družstevného bývania') }}</h2>
          <div class="row row-cols-5 justify-content-center mb-5">
            <div class="col-12 col-md-4">
              <div class="icon">
                <img src="../assets/images/druzstevne/bez_hypoteky_v1.svg" alt="">
              </div>
              <div class="text text-center">
                <h3 class="mb-4" v-html="$t('Bez potreby <br>získania hypotéky')"></h3>
                <p class="mb-0">{{ $t('Ako člen družstva nevstupujete do žiadneho vzťahu s bankou.') }}</p>
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="icon">
                <img src="../assets/images/druzstevne/pre_rodiny_mladych_seniorov.svg" alt="">
              </div>
              <div class="text text-center">
                <h3 class="mb-4" v-html="$t('Pohodlný model financovania <br>pre všetkých')"></h3>
                <p class="mb-0">{{ $t('Členovia družstva nemusia spĺňať rovnaké podmienky') }}</p>
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="icon">
                <img src="../assets/images/druzstevne/staci_20_ceny_bytu.svg" alt="">
              </div>
              <div class="text text-center">
                <h3 class="mb-4" v-html="$t('Stačí vám 20 % <br>z ceny bytu')"></h3>
                <p class="mb-0 text-center">{{ $t('Na získanie podielu v bytovom družstve vám postačí len 20 % z ceny bytu.') }}</p>
              </div>
            </div>
          </div>

          <div class="row row-cols-5 justify-content-center mb-5">
            <div class="col-12 col-md-4">
              <div class="icon">
                <img src="../assets/images/druzstevne/podpis_rezervacna_zmluva.svg" alt="">
              </div>
              <div class="text text-center">
                <h3 class="mb-4">{{ $t('Osobné vlastníctvo') }}</h3>
                <p class="mb-0">{{ $t('Po splatení ceny bytu môžete ako člen družstva požiadať') }}</p>
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="icon">
                <img src="../assets/images/druzstevne/dispozicia_podielom.svg" alt="">
              </div>
              <div class="text text-center">
                <h3 class="mb-4">{{ $t('Dispozícia s podielom') }}</h3>
                <p class="mb-0">{{ $t('Svoj podiel v družstve môžete predať alebo darovať inej osobe.') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <section class="section-3 dark-bg p-3">
      <div class="">
        <div class="row px-3">
          <div class="col-md-7 bg-img-dokoncene"></div>
          <div class="col-md-5 p-0 px-md-5 py-5 pb-custom-2">
            <h2 class="mb-4">{{ $t('Ponuka bytov v dokončenom projekte') }}</h2>
            <p class="mb-3">{{ $t('Bory Bývanie ponúka možnosť družstevného bývania v dokončenej etape') }}</p>
            <p class="mb-5">{{ $t('Etapa Bory Na Hrádzi bola skolaudovaná v roku 2024.') }}</p>
            <b-button to="/byvanie/na-hradzi" class="d-block d-md-inline-block px-5" squared variant="primary">{{ $t('Pozrieť ponuku bytov') }}</b-button>
          </div>
        </div>
      </div>
    </section>

    <section class="model-example dark-bg">
      <div class="container">
        <h2 class="text-center">
          {{ $t('Modelový príklad') }}
        </h2>
        <div class="row d-flex justify-content-center mb-5">
          <div class="col-12 col-md-5">
            <div class="box">
              <h3 class="text-center" v-html="$t('Mesačná splátka <br>hypotekárneho úveru')"></h3>
              <div class="d-flex justify-content-between align-items-center border-bottom py-3">
                <div class="label">{{ $t('Výška hypotéky') }}</div>
                <div class="price">201 680 €</div>
              </div>
              <div class="d-flex justify-content-between align-items-center border-bottom py-3">
                <div class="label">{{ $t('Doba splatnosti') }}</div>
                <div class="price">30 {{ $t('rokov') }}</div>
              </div>
              <div class="d-flex justify-content-between align-items-center border-bottom py-3">
                <div class="label">{{ $t('Úroková sadzba pre výpočet splátky') }}</div>
                <div class="price">3,85 % {{ $t('p. a.') }}</div>
              </div>
              <div class="d-flex justify-content-between align-items-center py-3 highlight">
                <div class="label">{{ $t('Mesačná splátka') }}</div>
                <div class="price">945,49 €</div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-5">
            <div class="box">
              <h3 class="text-center text-blue">{{ $t('Indikatívna mesačná splátka úveru na byt v rámci družstva') }}</h3>
              <div class="d-flex justify-content-between align-items-center border-bottom py-3">
                <div class="label">{{ $t('Výška úveru na byt v rámci družstva') }}</div>
                <div class="price">201 680 €</div>
              </div>
              <div class="d-flex justify-content-between align-items-center border-bottom py-3">
                <div class="label">{{ $t('Doba splatnosti') }}</div>
                <div class="price">40 {{ $t('rokov') }}</div>
              </div>
              <div class="d-flex justify-content-between align-items-center border-bottom py-3">
                <div class="label">{{ $t('Úroková sadzba pre výpočet splátky') }}</div>
                <div class="price">4,50 % {{ $t('p. a.') }}</div>
              </div>
              <div class="d-flex justify-content-between align-items-center py-3 highlight">
                <div class="label">{{ $t('Indikatívna mesačná splátka') }}</div>
                <div class="price">906,68 €</div>
              </div>
            </div>
          </div>
        </div>

        <p class="text-center disclaimer" v-html="$t('Modelový príklad je vypočítaný na dvojizbový byt')"></p>
      </div>
    </section>

    <Faq variant="druzstevne"></Faq>

    <ContactForm stage="druzstevne"></ContactForm>
  </div>
</template>

<script>
import ScrollTo from "@/utils/scrollTo.util";
import ContactForm from "@/components/shared/ContactForm";
import Faq from "@/components/shared/Faq.vue";
import store from "@/store";

export default {
  name: "DruzstevneByvanie",
  components: {ContactForm, Faq},
  data() {
    return {
      slickOptions: {
        infinite: false,
        adaptiveHeight: true,
        dots: true,
        arrows: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        // Any other options that can be got from plugin documentation
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
      },
    }
  },
  methods: {
    scrollTo(id) {
      const map = document.getElementById(id)
      map.scrollIntoView({behavior: "smooth", block: 'start'})

    },
  },
  mounted () {
    ScrollTo.hash(this,  () => window.scrollTo(0, 0))
  },
  computed: {
    locale() {
      return store.state.lang.$locale
    }
  }
}
</script>

<style lang="sass" scoped>
$md: 768px

.model-example
  background: var(--darkBlue)
  padding: 80px 0

  .disclaimer
    font-size: 14px

  .box
    border: 1px solid #fff
    padding: 30px

    @media (max-width: $md)
      margin-bottom: 15px

    h3
      margin-bottom: 20px

      @media (max-width: $md)
        font-size: 26px

    .label
      font-size: 18px

      @media (max-width: $md)
        font-size: 16px

    .price
      font-size: 22px
      font-weight: bold
      white-space: nowrap
      padding-left: 10px

      @media (max-width: $md)
        font-size: 16px
        text-align: right

    .highlight
      .label
        font-size: 22px
        font-weight: 500

        @media (max-width: $md)
          font-size: 18px

      .price
        font-size: 26px

        @media (max-width: $md)
          font-size: 18px

  h2
    font-size: 48px
    margin-bottom: 80px

    @media (max-width: $md)
      font-size: 30px

.about-bottom-2
  .bg
    background: url(../assets/images/bory3/bottom-image.jpg) center/cover no-repeat
.about-bottom
  .right-img
    background: url(../assets/images/cam_bedroom_01.jpg) center/cover no-repeat


.catalog
  background: var(--darkBlue)
  padding: 80px 0

  #catalog-slider
    overflow: hidden

  h2
    font-size: 48px
    padding-left: 8px
    margin-bottom: 80px

  .slide
    position: relative

    .info
      position: absolute
      padding: 50px 20px 20px
      bottom: 0
      left: 0
      width: 100%
      background: linear-gradient(to top, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0))
      color: #fff

      .discount-text
        font-size: 34px
        font-weight: 500
        margin-bottom: 10px

    .type
      position: absolute
      left: 0
      bottom: 0
      background: var(--blue)
      padding: 8px 30px
      font-size: 20px
      color: var(--dark)

.princip
  h2
    font-size: 40px
    @media (max-width: $md)
      font-size: 30px
      margin-bottom: 20px
  .box
    position: relative
    padding: 0

    .text
      padding: 0 30px

    p
      font-size: 16px

    &:last-child
      &:after
        display: none

    .icon
      text-align: center
      border-bottom: 2px solid var(--textDark)
      margin-bottom: 25px
      position: relative

      @media (max-width: $md)
        border-bottom: none
        margin-bottom: 0

      &:after
        content: ""
        width: 12px
        height: 12px
        position: absolute
        bottom: -7px
        left: 50%
        transform: translateX(-6px)
        z-index: 1
        background: var(--textDark)
        border-radius: 50%

        @media (max-width: $md)
          display: none

        @media (max-width: $md)
          display: none

      img
        max-height: 110px

.vyhody
  background: var(--grey)
  padding: 80px 0

  h2
    font-size: 40px
    @media (max-width: $md)
      font-size: 30px
      margin-bottom: 20px

  .text
    h3
      font-size: 22px

      &.custom-margin
        margin-top: 15px
        margin-bottom: 35px

  .icon
    text-align: center

    img
      max-height: 110px
.section-3
  background: var(--grey)
  color: #fff
  text-align: left

  .pb-custom
    padding-bottom: 50px !important

    @media (max-width: $md)
      padding-bottom: 30px !important

    &-2
      padding-bottom: 130px !important
      @media (max-width: $md)
        padding-bottom: 30px !important

  &.dark-bg
    background: var(--text-dark)

  &.free-offer
    .bg-img
      background: url(../assets/images/druzstevne/druzstevne-1.jpg) center/cover no-repeat
  .bg-img
    background: url("../assets/images/Bory_Promenada-3.jpg") center/cover no-repeat
    @media (max-width: $md)
      height: 40vh
      background-size: cover
  .bg-img-2
    background: url(../assets/images/druzstevne/druzstevne-2.jpg) center/cover no-repeat
    @media (max-width: $md)
      height: 40vh
      background-size: cover
  .bg-img-3
    background: url("../assets/images/nabytok/story_info_bh4a.jpg") center/cover no-repeat
    @media (max-width: $md)
      height: 40vh
      background-size: cover
  .bg-img-dokoncene
    background: url("../assets/images/druzstevne/druzstevne-dokoncene.jpg") center/cover no-repeat
    @media (max-width: $md)
      height: 40vh
      background-size: cover
  
  h2
    font-size: 55px
    line-height: 60px
    font-weight: 300
    margin-bottom: 20px
    @media (max-width: $md)
      font-size: 28px
      line-height: 40px
      letter-spacing: -1px
      margin-bottom: 15px
  p
    max-width: 360px
    font-weight: 500
    &:last-child
      margin-bottom: 120px
      @media (max-width: $md)
        margin-bottom: 0
  .bg-col
    height: 800px
    @media (max-width: $md)
      height: 60vh
      margin-bottom: 16px
      padding: 30px
    h3
      font-size: 28px
      line-height: 32px
      font-weight: 400
      margin-bottom: 20px
    p
      font-size: 16px
      line-height: 21px
      font-weight: 500
      @media (max-width: $md)
        font-size: 12px
        line-height: 16px
        max-width: 100%
  .bg-col-1
    background: linear-gradient(179.37deg, rgba(0, 0, 0, 0.53) 0.71%, rgba(0, 0, 0, 0) 99.63%), url("../assets/images/bory3/bory3.jpg") center/cover no-repeat
  .bg-col-2
    background: linear-gradient(179.37deg, rgba(0, 0, 0, 0.53) 0.71%, rgba(0, 0, 0, 0) 99.63%), url("../assets/images/Bory_Promenada-1.jpg") bottom/cover no-repeat
  .bg-col-3
    background: linear-gradient(179.37deg, rgba(0, 0, 0, 0.53) 0.71%, rgba(0, 0, 0, 0) 99.63%), url("../assets/images/bory3/bory3-ihriska.jpg") center/cover no-repeat
    background-position: -350px center
    @media (max-width: $md)
      background-position: center
  .col-md-4
    padding-left: 8px
    padding-right: 8px
.home
  background: linear-gradient(179.37deg, rgba(0, 0, 0, 0.53) 0.71%, rgba(0, 0, 0, 0) 99.63%), url("../assets/images/druzstevne/druzstevne-header.jpg") top/cover no-repeat
  p
    margin-bottom: 30px
    max-width: 770px

    &.disclaimer
      font-size: 14px
      font-weight: bold
      font-style: italic

  // ukrajinské "Кооперативне" sa na mobile pri 44px nezmestí na šírku
  h1.h1-ua
    @media (max-width: $md)
      font-size: 36px

  .badge-offer
    position: absolute
    top: -220px
    right: -220px
    width: 240px

    @media (max-width: $md)
      top: -70%
      left: 50%
      transform: translateX(-50%)
      max-width: 160px

.district
  background: var(--darkBlue)
  img
    width: 100%
.top
  h2
    font-weight: 300
    font-size: 55px
    line-height: 60px
    letter-spacing: -3px
    @media (max-width: $md)
      font-size: 40px
      line-height: 40px
      letter-spacing: -2px
  p
    font-weight: 500
    max-width: 415px
</style>
